module.exports = __webpack_public_path__ + "img/xai.ee7ca60.gif";